import React, { Fragment } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import styles from './Apps.module.css'

import PageHead, { PageHeading } from 'Layout/PageHead'
import PageContent from 'Layout/PageContent'

import AppsTileList from './AppsTileList'
import AppDetails from './AppDetails'

const Apps = () => {
  return (
    <Fragment>
      <PageHead>
        <PageHeading>Apps</PageHeading>
      </PageHead>
      <PageContent className={styles.Content}>
        <Routes>
          <Route index element={<AppsTileList />} />
          <Route path=':appName/*' element={<AppDetails />} />
          <Route path='*' element={<Navigate path='' replace />} />
        </Routes>
      </PageContent>
    </Fragment>
  )
}

export default Apps
